// extracted by mini-css-extract-plugin
export default {"shell":"OnboardingLayout_shell__b-OyG","content":"OnboardingLayout_content__UBmsu"};